import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CmsStructureComponent } from './cms-structure.component';

const routes: Routes = [{ path: '', component: CmsStructureComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CmsStructureRoutingModule { }
